import { useEffect, useState } from "react";
import { Mail } from "lucide-react";
import { toast } from "sonner";
import { http } from "../../lib/api";

export function SiteVisitorsEmail({ siteId }) {
  const [v, setV] = useState("");
  const [saved, setSaved] = useState("");
  useEffect(() => {
    http.get(`/sites/${siteId}/visitors-email`).then((r) => { setV(r.data.visitors_email); setSaved(r.data.visitors_email); });
  }, [siteId]);
  const save = async (e) => {
    e.preventDefault();
    try { const r = await http.put(`/sites/${siteId}/visitors-email`, { visitors_email: v.trim() || null }); setSaved(r.data.visitors_email); toast.success(r.data.visitors_email ? "Adresse enregistrée" : "Adresse supprimée"); }
    catch (err) { toast.error(err.response?.status === 422 ? "Adresse e-mail invalide" : err.response?.data?.detail || "Erreur"); }
  };
  return (
    <form onSubmit={save} className="bg-white border border-slate-200 rounded-lg p-4" data-testid="site-visitors-email-card">
      <div className="font-bold inline-flex items-center gap-2"><Mail className="h-4 w-4 text-amber-600" />E-mail des agents du site</div>
      <p className="text-xs text-slate-500 mt-1">Reçoit un e-mail à chaque annonce de visiteur : nouvelle, modifiée ou annulée.</p>
      <div className="flex flex-wrap gap-2 mt-3">
        <input data-testid="site-visitors-email-input" type="email" value={v} onChange={(e) => setV(e.target.value)} placeholder="ex. poste.securite@client.fr" className="flex-1 min-w-[220px] rounded-md border border-slate-300 px-3 py-2 text-sm" />
        <button data-testid="site-visitors-email-save" disabled={v.trim() === saved} className="px-4 py-2 rounded-md bg-slate-900 text-white text-sm font-semibold disabled:opacity-40 transition-opacity">Enregistrer</button>
      </div>
      {!saved && <p className="text-xs text-amber-700 mt-2" data-testid="site-visitors-email-missing">Aucune adresse : les agents ne reçoivent pas les annonces par e-mail.</p>}
    </form>
  );
}
